import React, { useEffect, useState } from "react";
import DOMPurify from 'dompurify';
import { useParams, useNavigate } from "react-router-dom";
import { format } from "date-fns";

import Accessibility from "../../../components/UI/Accessibility";
import ContentBox from "../../../components/UI/ContentBox";
import Footer from "../../../components/UI/Footer";
import Menu from "../../../components/UI/Menu";
import {
  Container,
  Section,
  Question,
  Choices,
  ImgContainer,
  ImgBlock,
  Table,
  ButtonGroup,
} from "./styles";
import Banner from "../../../components/UI/Banner";

import useApi from "../../../hooks/useApi";
import { useAuth } from "../../../hooks/useAuth";

import ReadMoreButton from "../../../components/UI/ReadMoreButton";
import InputText from "../../../components/UI/Inputs/InputText";
import InputCheck from "../../../components/UI/Inputs/InputCheck";
import InputRadio from "../../../components/UI/Inputs/InputRadio";
import InputDate from "../../../components/UI/Inputs/InputDate";
import Modal from "../../../components/UI/Modal";
import FullScreenLoading from "../../../components/UI/FullScreenLoading";
import { images } from "../../../constants";

const FillForms = () => {

  const { id, idformresponse } = useParams();

  const navigate = useNavigate();

  const [forms, setForms] = useState({});

  const [formResponse, setFormResponse] = useState({});

  const cleanText = (text)=> {return DOMPurify.sanitize(text)};

  const { user } = useAuth();

  const [textResponseModal, setTextResponseModal] = useState({open:false,execute:()=>{},text:""});

  const [textResponse, setTextResponse] = useState("");

  const [openModal, setOpenModal] = useState("");

  const [submitButton, setSubmitButton] = useState(false);

  const [loadForms, loadFormsInfo] = useApi({
    debounceDelay: 0,
    url: "canalPedagogico/form/completeForm",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        if(response.data.length>0){
          console.log("loadForms",response);
          let temp = response.data[0];
          temp.form.sections.forEach((section)=>{
            let rowGroup = null;
            section.questions.forEach((question,index)=>{
              if(question.rowGroup){
                if(rowGroup!==question.rowGroup){
                  question.group=true;
                  question.listgroup=section.questions.filter((questionfilter)=>{return questionfilter.rowGroup===question.rowGroup});
                  rowGroup=question.rowGroup;
                }
              }
            })
          })
          console.log("teste temp",temp);
          setForms(temp);
        }
      }
    },
  });

  const [getFormsResponse, loadFormsResponseInfo] = useApi({
    debounceDelay: 0,
    url: "canalPedagogico/form/allResponses",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        console.log("getFormsResponse",response);
        if(response.data.length>0){
          console.log("getFormsResponse",response);
          setFormResponse(response.data[0]);
          let flag = true;
          forms.form?.sections?.forEach((section)=>{
            section.questions.forEach((question)=>{
              if(question.required){
                if(response.data[0].formResponses.questionresponses.filter((questionresponse)=>{return questionresponse.idquestion===question.idquestion}).length===0){
                  console.log("questão não preenchida: ",question.text)
                  flag = false;
                }
                else{
                  if(question.type==="text"){
                    if(response.data[0].formResponses.questionresponses.filter((questionresponse)=>{return questionresponse.idquestion===question.idquestion})[0]?.textResponse===""){
                      console.log("questão não preenchida: ",question.text)
                      flag = false;
                    }
                  }
                }
              }
            })
          })
          setSubmitButton(flag);
        }
      }
    },
  });

  const [createQuestionResponse, createQuestionResponseInfo] = useApi({
    debounceDelay: 500,
    url: "canalPedagogico/form/questionResponse",
    method: "post",
    onCompleted: (response) => {
      if (!response.error) {
        getFormsResponse({
          params: {
            idFormResponse:idformresponse
          },
        });
        console.log("resposta cadastrada com sucesso");
      }
      else{
        console.log("erro ao cadastrar resposta");
      }
    },
  });

  const [updatedQuestionResponse, updatedQuestionResponseInfo] = useApi({
    debounceDelay: 500,
    url: "canalPedagogico/form/questionResponse",
    method: "put",
    onCompleted: (response) => {
      if (!response.error) {
        getFormsResponse({
          params: {
            idFormResponse:idformresponse
          },
        });
        console.log("resposta atualizada com sucesso");
      }
      else{
        console.log("erro ao atualizar a resposta");
      }
    },
  });

  const [deleteQuestionResponse, deleteQuestionResponseInfo] = useApi({
    debounceDelay: 500,
    url: "canalPedagogico/form/questionResponse",
    method: "delete",
    onCompleted: (response) => {
      if (!response.error) {
        getFormsResponse({
          params: {
            idFormResponse:idformresponse
          },
        });
        console.log("resposta deletada com sucesso");
      }
      else{
        console.log("erro ao deletar resposta");
      }
    },
  });

  const [submitForm, submitFormInfo] = useApi({
    debounceDelay: 0,
    url: "canalPedagogico/form/response/submit",
    method: "put",
    onCompleted: (response) => {
      if (!response.error) {
        setOpenModal("Finalizado");
        console.log("formulario finalizado com sucesso");
      }
      else{
        console.log("erro ao finalizar o formulario");
      }
    },
  });

  const checkInt = (value) => {
    if (value !== "" && !isNaN(value)) {
      return parseInt(value);
    }
    return value;
  };

  const handleChoiceRadio = (question,choice)=>{
    if(formResponse?.formResponses.questionresponses===null || 
       formResponse?.formResponses?.questionresponses?.filter((response)=>{return response.idquestion===question}).length===0){
      console.log("create");
      createQuestionResponse({
        data: {
          idFormResponse:formResponse?.formResponses?.idFormResponse,
          idquestion:question,
          idchoice:choice,
        },
        debounced: true,
      });
    }
    else{
      console.log("update");
      let update = formResponse?.formResponses?.questionresponses?.find((response)=>{return response.idquestion===question});
      updatedQuestionResponse({
        data: {
          idFormQuestionResponse:update?.idFormQuestionResponse,
          idFormResponse:formResponse?.formResponses?.idFormResponse,
          idquestion:question,
          idchoice:choice,
        },
        debounced: true,
      });
    }
  }

  const handleCheckBox = (question,choice)=>{
    if(formResponse?.formResponses.questionresponses===null || 
       formResponse?.formResponses?.questionresponses?.filter((response)=>{return response.idquestion===question && response.idchoice===choice}).length===0){
      console.log("create");
      createQuestionResponse({
        data: {
          idFormResponse:formResponse?.formResponses?.idFormResponse,
          idquestion:question,
          idchoice:choice,
        },
        debounced: true,
      });
    }
    else{
      let update = formResponse?.formResponses?.questionresponses?.find((response)=>{return response.idquestion===question && response.idchoice===choice});
      console.log("update",update);
      deleteQuestionResponse({
        data: {
          idFormQuestionResponse:update?.idFormQuestionResponse,
        },
        debounced: true,
      });
    }
  }

  const handleText = (question,text)=>{
    console.log("text",text);
    if(formResponse?.formResponses.questionresponses===null || 
       formResponse?.formResponses?.questionresponses?.filter((response)=>{return response.idquestion===question}).length===0){
      console.log("create");
      createQuestionResponse({
        data: {
          idFormResponse:formResponse?.formResponses?.idFormResponse,
          idquestion:question,
          textResponse:text,
        },
        debounced: true,
      });
    }
    else{
      console.log("update");
      let update = formResponse?.formResponses?.questionresponses?.find((response)=>{return response.idquestion===question});
      updatedQuestionResponse({
        data: {
          idFormQuestionResponse:update?.idFormQuestionResponse,
          idFormResponse:formResponse?.formResponses?.idFormResponse,
          idquestion:question,
          textResponse:text,
        },
        debounced: true,
      });
    }
  }

  const getData = (question,response)=>{
    if(response?.formResponses?.questionresponses?.filter((response)=>{return response.idquestion===question}).length===0){
      return "";
    }
    else{
      let temp = formResponse?.formResponses?.questionresponses?.find((response)=>{return response.idquestion===question});
      return checkInt(temp?.textResponse);
    }
  }

  useEffect(() => {
    if(id){
      loadForms({
        params: {
          idform: id,
        },
      });
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if(forms?.form?.idform){
      getFormsResponse({
          params: {
            idFormResponse:idformresponse
          },
        });
    }
    // eslint-disable-next-line
  }, [forms]);

  return (
    <Container>
      {(
        loadFormsInfo.loading ||
        loadFormsResponseInfo.loading || 
        createQuestionResponseInfo.loading ||
        updatedQuestionResponseInfo.loading ||
        submitFormInfo.loading ||
        deleteQuestionResponseInfo.loading
      ) && <FullScreenLoading />}
      <Menu />
      <Banner icon={images.iconForms}>Avaliação de Contexto</Banner>
      <ContentBox>
        <ImgContainer>
          {forms?.form?.formMedias?.filter((media)=>{return media.position==="before"})?.map((media)=><ImgBlock key={media.idmedia}>
            <img src={`${process.env.REACT_APP_CDN_URL}canalPedagogico/form/${media.url}`} />
          </ImgBlock>)}
        </ImgContainer>

        <div dangerouslySetInnerHTML={{ __html: cleanText(forms?.form?.description) }} />

        <ImgContainer>
          {forms?.form?.formMedias?.filter((media)=>{return media.position==="after"})?.map((media)=><ImgBlock key={media.idmedia}>
            <img src={`${process.env.REACT_APP_CDN_URL}canalPedagogico/form/${media.url}`}/>
          </ImgBlock>)}
        </ImgContainer>

        {forms?.form?.sections?.map((section)=><Section key={section.idsection}>
                    
          <ImgContainer>
            {section.formSectionMedias?.filter((media)=>{return media.position==="before"})?.map((media)=><ImgBlock key={media.idmedia}>
              <img src={`${process.env.REACT_APP_CDN_URL}canalPedagogico/form/section/${media.url}`}/>
            </ImgBlock>)}
          </ImgContainer>

          {section.title}
          
          {section.description}

          <ImgContainer>
            {section.formSectionMedias?.filter((media)=>{return media.position==="after"})?.map((media)=><ImgBlock key={media.idmedia}>
              <img src={`${process.env.REACT_APP_CDN_URL}canalPedagogico/form/section/${media.url}`}/>
            </ImgBlock>)}
          </ImgContainer>

          {section.questions.map((question)=><Question key={question.idquestion}>

            {question.type!=="rowquestion_radio" && question.type!=="rowquestion_checkbox" && <>

              <ImgContainer>
                {question.formQuestionMedias?.filter((media)=>{return media.position==="before"})?.map((media)=><ImgBlock key={media.idmedia}>
                  <img src={`${process.env.REACT_APP_CDN_URL}canalPedagogico/form/question/${media.url}`}/>
                </ImgBlock>)}
              </ImgContainer>

              <div>{question.text}</div>

              <ImgContainer>
                {question.formQuestionMedias?.filter((media)=>{return media.position==="after"})?.map((media)=><ImgBlock key={media.idmedia}>
                  <img src={`${process.env.REACT_APP_CDN_URL}canalPedagogico/form/question/${media.url}`}/>
                </ImgBlock>)}
              </ImgContainer>

            </>}

            {/* {question.type==="text" && <InputText placeholder="" columns={3} key={question.idquestion}/>} */}

            {question.type==="text" && (formResponse?.formResponses?.questionresponses?.filter((response)=>{return response.idquestion===question.idquestion}).length>0) && <div>
              <b>{
                formResponse?.formResponses?.questionresponses?.filter((response)=>{return response.idquestion===question.idquestion})[0]?.textResponse
              }</b></div>
            }

            {question.type==="text" && !(formResponse?.formResponses?.submitted) && <ReadMoreButton 
                                            text="Responder" 
                                            onClick={()=>{
              setTextResponse(
                (formResponse?.formResponses?.questionresponses?.filter((response)=>{return response.idquestion===question.idquestion}).length>0)?
                (formResponse?.formResponses?.questionresponses?.filter((response)=>{return response.idquestion===question.idquestion})[0]?.textResponse):
                ""
              );
              setTextResponseModal({open:true,text:question.text,execute:(text)=>{handleText(question.idquestion,text)}});
              }}/>}
            
            {question.type==="radio" && <Choices key={question.idquestion}>
              {question.choices?.map((choice)=><InputRadio 
                disabled={formResponse?.formResponses?.submitted}
                key={choice.idchoice}
                text={choice.text}
                name={question.idquestion}
                checked={formResponse?.formResponses?.questionresponses?.filter(
                  (response)=>{
                    return response.idquestion===question.idquestion && response.idchoice===choice.idchoice}
                ).length>0}
                onClick={()=>{handleChoiceRadio(question.idquestion,choice.idchoice)}}
              />)}
            </Choices>}

            {question.type==="date" && !(formResponse?.formResponses?.submitted) && <InputDate value={getData(question.idquestion,formResponse)} setField={(name,data)=>{handleText(question.idquestion,data)}} name="data" label="" />}
            {question.type==="date" && (formResponse?.formResponses?.submitted) && <div>{format(new Date(getData(question.idquestion,formResponse)), " dd/MM/yyyy ")}</div>}

            {question.type==="checkbox" && <Choices key={question.idquestion}>
              {question.choices?.map((choice)=><InputCheck 
                disabled={formResponse?.formResponses?.submitted}
                key={choice.idchoice}
                text={choice.text}
                checked={formResponse?.formResponses?.questionresponses?.filter(
                  (response)=>{
                    return response.idquestion===question.idquestion && response.idchoice===choice.idchoice}
                ).length>0}
                onClick={()=>{handleCheckBox(question.idquestion,choice.idchoice)}}
              />)}
            </Choices>}

            {question.group && <Table>
              <thead>
                <tr key={`trh-${question.idquestion}`}>
                  <th></th>
                  {question.choices.map((choice,index)=><th key={`th-${choice.idchoice}`}>{choice.text}</th>)}
                </tr>
              </thead>
              <tbody>
                {question.type==="rowquestion_radio" && question.listgroup.map((rowquestion)=><tr key={`tr-${rowquestion.idquestion}`}>
                  <td key={question.idquestion}>{rowquestion.text}</td>
                  {rowquestion.choices.map((choice)=><td key={`td-${choice.idchoice}`}>
                    <InputRadio 
                      disabled={formResponse?.formResponses?.submitted}
                      key={`ir-${choice.idchoice}`}
                      text={``}
                      name={rowquestion.idquestion}
                      checked={formResponse?.formResponses?.questionresponses?.filter(
                        (response)=>{
                          return response.idquestion===rowquestion.idquestion && response.idchoice===choice.idchoice}
                      ).length>0}
                      onClick={()=>{handleChoiceRadio(rowquestion.idquestion,choice.idchoice)}}
                    />
                  </td>)}
                </tr>)}

                {question.type==="rowquestion_checkbox" && question.listgroup.map((rowquestion)=><tr key={`tr-${question.idquestion}`}>
                  <td key={question.idquestion}>{rowquestion.text}</td>
                  {rowquestion.choices.map((choice)=><td key={`td-${choice.idchoice}`}>
                    <InputCheck 
                      disabled={formResponse?.formResponses?.submitted}
                      key={`ic-${choice.idchoice}`}
                      text={""}
                      checked={formResponse?.formResponses?.questionresponses?.filter(
                        (response)=>{
                          return response.idquestion===rowquestion.idquestion && response.idchoice===choice.idchoice}
                      ).length>0}
                      onClick={()=>{handleCheckBox(rowquestion.idquestion,choice.idchoice)}}
                    />
                  </td>)}
                </tr>)}
              </tbody>

            </Table>}
            
          </Question>)}
        </Section>)}

        <Modal open={textResponseModal.open} buttonClose={false}>
          {textResponseModal.text}
          <InputText placeholder="" columns={3} value={textResponse} onChange={(value)=>{setTextResponse(value.target.value)}}/>
          <ButtonGroup>
            <ReadMoreButton text="OK" onClick={()=>{textResponseModal.execute(textResponse.trim());setTextResponseModal({open:false,execute:()=>{},text:""});}}/>
            <ReadMoreButton text="Cancelar" onClick={()=>{setTextResponseModal({open:false,execute:()=>{},text:""})}}/>
          </ButtonGroup>
        </Modal>

        <Modal open={openModal==="Finalizado"} buttonClose={false}>
          <div>Formulário finalizado com sucesso</div>
          <ReadMoreButton 
            text="OK"
            onClick={()=>{navigate(`/avaliacaocontexto`);}}
          />
        </Modal>
        
        <ButtonGroup>
          <ReadMoreButton 
            text="Voltar"
            onClick={()=>{navigate(-1)}}
          />
          
          {!(formResponse?.formResponses?.submitted) && <ReadMoreButton 
            text="Finalizar formulário"
            onClick={()=>{submitForm({
              data: {
                idFormResponse:formResponse.formResponses.idFormResponse,
                idform:id
              },
            });}}
            disabled={!submitButton}
          />}
        </ButtonGroup>
      </ContentBox>
      <Footer />
    </Container>
  );
};

export default FillForms;